import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import ResponsiveLayoutCard from "../../components/onboarding/ResponsiveLayoutCard/ResponsiveLayoutCard";
import "./signup.css";
import { getAPIClient } from "../../apiClient";
import { useBranding } from "../../branding/useBranding";
import { useTranslation } from "react-i18next";
import logout from "../../utils/logout";
import { getAuth } from "firebase/auth";

export function SignUpTemplate() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const branding = useBranding();

  async function signOut() {
    await logout(getAPIClient(), getAuth());
    navigate("/");
  }

  return (
    <section className="md:p-12 max-md:overflow-hidden h-screen dark:!bg-dark">
      <Link
        to="/"
        className={`is-${branding.backlinkColor}-text max-md:hidden`}
        onClick={() => signOut()}
      >
        {t("onboarding.signup-back-button")}
      </Link>
      <ResponsiveLayoutCard>
        <div className="flex">
          <div className="flex-1/2">
            <Outlet />
          </div>
          <div className="flex-1/2 max-md:!hidden signup-image rounded-tr-[22px] rounded-br-[22px]">
            <img
              src="/assets/images/Docket_Logo_Blue.png"
              alt="Docket logo"
              className="docket-signup-image"
            />
            <img className="branding-image" src={`/${branding.loginBackgroundImage}`} />
          </div>
        </div>
      </ResponsiveLayoutCard>
    </section>
  );
}

export default SignUpTemplate;
